// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__FSkDf"};